// extracted by mini-css-extract-plugin
module.exports = {"LanguagePicker":"LanguagePicker_LanguagePicker__tsg8h"};